import { Directive, Input, TemplateRef, ViewContainerRef, inject, OnInit, OnDestroy } from '@angular/core';
import { AppService } from '@services/user/app.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[libHasRole]',
  standalone: true
})
export class HasRoleDirective implements OnInit, OnDestroy {
  private templateRef = inject(TemplateRef<any>);
  private viewContainer = inject(ViewContainerRef);
  private appService = inject(AppService);

  private roles: string[] = [];
  private sub = new Subscription();

  @Input('libHasRole') set appHasRole(roles: string | string[]) {
    if (typeof roles === 'string') {
      this.roles = [roles];
    } else {
      this.roles = roles;
    }
    this.updateView();
  }

  ngOnInit() {
    this.sub.add(
      this.appService.user$.subscribe(() => {
        this.updateView();
      })
    );
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  private updateView() {
    const user = (this.appService.currentUser || this.appService.getActiveUser()) as any;
    
    if (!this.roles || this.roles.length === 0) {
      this.show();
      return;
    }

    if (user) {
      if (user.is_admin && this.roles.some(r => r.toUpperCase() === 'ADMIN')) {
        this.show();
        return;
      }

      if (user.roles && Array.isArray(user.roles)) {
        const userRoles = user.roles.map((r: any) => {
          const val = typeof r === 'string' ? r : r?.name;
          return typeof val === 'string' ? val.toUpperCase() : '';
        });
        const hasAccess = this.roles.some(role => userRoles.includes(role.toUpperCase()));
        
        if (hasAccess) {
          this.show();
          return;
        }
      }

      if (typeof user.role === 'string' && this.roles.some(r => r.toUpperCase() === user.role.toUpperCase())) {
        this.show();
        return;
      }

      this.hide();
    } else {
      this.hide();
    }
  }

  private hasView = false;

  private show() {
    if (!this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    }
  }

  private hide() {
    if (this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
